// `/tickets/new`: never a screen of its own. It mints a new draft's GUID and replaces
// itself with `/tickets/drafts/<guid>`, carrying its query string (`?parent=…`,
// `?customer=…`) as a ONE-TIME prefill in router state, not in the new address
// (docs/superpowers/specs/2026-10-13-multi-ticket-drafts-design.md, "Addresses";
// components/drafts/draft-address.js). So every existing link to `/tickets/new` keeps
// working, and Back skips this address.

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { newDraftLocation } from '../../components/drafts/draft-address.js';

export default function NewDraft() {
  const navigate = useNavigate();
  const { search } = useLocation();
  // Minted once per mount, so a re-render cannot send the agent to a second new draft.
  const [target] = useState(() => newDraftLocation(search));

  useEffect(() => {
    navigate(target.to, { replace: true, state: target.state });
  }, [navigate, target]);

  return null;
}
